import ProjectIndexPage from "lx/projectIndexPage";

export { ProjectIndexPage };

customElements.define(
  "lx-project-index-page",
  ProjectIndexPage.CustomElementConstructor
);
